import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Report"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2 1H11V2.5H2V1ZM5.75 10V22C5.75 22.8284 6.42157 23.5 7.25 23.5H20.75C21.5784 23.5 22.25 22.8284 22.25 22V6.25C22.25 5.42157 21.5784 4.75 20.75 4.75H18.5V4C18.5 3.17157 17.8284 2.5 17 2.5H11C10.1716 2.5 9.5 3.17157 9.5 4V4.75H8V6.25H9.5V8.5H18.5V6.25H20.75V22H7.25V6.25H5.75C5.75 5.42157 6.42157 4.75 7.25 4.75H2V6.25H5.75V8.5H2V10H5.75ZM17 4H11V7H17V4Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Report.vue"]]);
